"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SokoBidBreadCrumb = exports.SystemBreadCrumb = void 0;
var sok_ui_1 = require("@caddigital/sok-ui");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var SystemBreadCrumb = function () { return (React.createElement(sok_ui_1.BreadCrumb, null,
    React.createElement(react_router_dom_1.Link, { to: "/" }, "SokoPro"),
    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/system')),
    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/admin/activity')))); };
exports.SystemBreadCrumb = SystemBreadCrumb;
var SokoBidBreadCrumb = function (props) {
    return (React.createElement(sok_ui_1.BreadCrumb, null,
        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.language, "/projects/").concat(props.briefcase.project) }, props.briefcase.projectName),
        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.language, "/projects/").concat(props.briefcase.project, "/briefcases") }, (0, translation_1.getLocalization)('breadcrumb/sokobid')),
        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.language, "/briefcase/").concat(props.briefcase.id) }, props.briefcase.name),
        React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/admin/activity'))));
};
exports.SokoBidBreadCrumb = SokoBidBreadCrumb;
